module.exports = __webpack_public_path__ + "img/demand.207e5666.svg";